export const UNASSIGNED_EXPERIENCE_FILTER_ID = 'unassigned';
export const UNASSIGNED_EXPERIENCE_FILTER_TYPE = 'UnassignedExperience' as const;
